import { PageEnvironment } from '@moonpig/web-core-app'

type HeadLinkTags = {
  path: string
  offset: number
  galleryPageSize: number
  count: number
  environment?: PageEnvironment
  canonicalSubPath?: string
}

const getCanonicalOffset = (offset: number, href: string): string | null => {
  try {
    const canonicalUrl = new URL(href)
    if (offset) {
      canonicalUrl.searchParams.set('offset', String(offset))
    } else {
      canonicalUrl.searchParams.delete('offset')
    }
    return canonicalUrl.href
  } catch {
    return null
  }
}

const getNextOffset = (
  offset: number,
  galleryPageSize: number,
  href: string,
  totalCount: number,
): string | null => {
  try {
    const nextOffset = offset + galleryPageSize
    if (nextOffset >= totalCount) {
      return null
    }
    const nextUrl = new URL(href)
    nextUrl.searchParams.set('offset', String(nextOffset))
    return nextUrl.href
  } catch {
    /* istanbul ignore next */
    return null
  }
}

const getPrevOffset = (
  offset: number,
  galleryPageSize: number,
  href: string,
): string | null => {
  try {
    const prevOffset = offset - galleryPageSize
    if (prevOffset < 0) {
      return null
    }
    const prevUrl = new URL(href)
    if (prevOffset >= galleryPageSize) {
      prevUrl.searchParams.set('offset', String(prevOffset))
    } else {
      prevUrl.searchParams.delete('offset')
    }
    return prevUrl.href
  } catch {
    /* istanbul ignore next */
    return null
  }
}

export const getHeadLinksTags = ({
  path,
  offset,
  galleryPageSize,
  count,
  environment,
  canonicalSubPath,
}: HeadLinkTags) => {
  if (environment) {
    const href = environment.hostUrl + (canonicalSubPath || path)

    const canonical = getCanonicalOffset(offset, href)

    const next = getNextOffset(offset, galleryPageSize, href, count)
    const prev = getPrevOffset(offset, galleryPageSize, href)

    return {
      canonical,
      next,
      prev,
    }
  }
  return null
}
